import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "report";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //生产报表
    async GetProductionReport({ commit }, payload) {
      let result = await api.get(
        `/api/ProductionReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //出塘报表
    async GetOutPondReport({ commit }, payload) {
      let result = await api.get(
        `/api/SaleReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //损失报表
    async GetLossReport({ commit }, payload) {
      let result = await api.get(
        `/api/LossReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //物资耗用报表
    async getMaterialReport({ commit }, payload) {
      let result = await api.get(
        `/api/MaterialReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //物资耗用报表
    async getStockReport({ commit }, payload) {
      let result = await api.get(
        `/api/StockReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    //库存明细报表
    async getStockDetailReport({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingProductReport/GetWeighingStockDetailReport?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
    //库存汇总报表
    async getStockTotalReport({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingProductReport/GetWeighingStockSummaryReport?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
    //亏称明细报表
    async getLossWeightReport({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingLossReport?${queryString.stringify(payload)}`
      );
      return result.data;
    },
  },
});

export default moduleName;
